import { css } from '@emotion/css'
import { TablePagination } from '@mui/material'
import { Box } from '@mui/system'
import { observer } from 'mobx-react'
import { default as React } from 'react'
import { useNewPagination } from './hooks/useNewPagination'
import PageIndicator from './PageIndicator'
import PaginationControls from './PaginationControls'

type NewPaginationProps = {
  hidePageSign: boolean
  totalSize: number
  store: any
  rowsPerPageOptions: number[]
  setRenderTable?: React.Dispatch<React.SetStateAction<boolean>>
}

function NewPagination({
  hidePageSign,
  totalSize,
  store,
  rowsPerPageOptions,
  setRenderTable,
}: NewPaginationProps) {
  const {
    classes,
    handleInputPageChange,
    labelDisableRows,
    onPageChange,
    onRowsPerPageChange,
    maxPage,
    page,
    pageInputValue,
    size,
  } = useNewPagination(store, totalSize, setRenderTable)

  return (
    <Box sx={classes.pageNumberBlock}>
      <PageIndicator
        pageInputValue={pageInputValue}
        handleInputPageChange={handleInputPageChange}
        maxPage={maxPage}
        hidePageSign={hidePageSign}
        size={size}
      />
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions ?? [50, 100]}
        sx={{
          ...classes.tablePagination,
          ...classes.hideOnTabletsPaginateElements,
          overflow: 'hidden',
        }}
        classes={{
          // @ts-ignore
          root: css({
            minWidth: 'fit-content',
            overflowY: 'hidden !important',
            color: 'black !important',
          }),
        }}
        component='div'
        count={totalSize || 1}
        rowsPerPage={size || 1}
        page={page}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        labelRowsPerPage='Размер'
        labelDisplayedRows={labelDisableRows}
        ActionsComponent={PaginationControls}
      />
    </Box>
  )
}

export default observer(NewPagination)
